import React from 'react';

function Tracking() {
  return (
    <div className="rounded-xl bg-white p-5 shadow-md">
      <h2 className="mb-4 text-lg font-bold text-amber-600"><span role="img" aria-label="chart">📊</span> Suivi &amp; Contrôle des Rendez-vous</h2>
      <div className="mb-3 rounded-lg border border-amber-200 bg-amber-50 p-3">
        <div className="font-semibold text-amber-900"><span role="img" aria-label="clipboard">📋</span> Tableau de Bord Référent</div>
        <p className="text-sm text-amber-900/80">Suivez en temps réel l'état des rendez-vous que vous avez programmés.</p>
      </div>
      <div className="rounded-lg border border-blue-200 bg-blue-50 p-3">
        <div className="font-semibold text-blue-900">ℹ️ Aucun rendez-vous à suivre pour le moment</div>
        <p className="text-sm text-blue-900/80">Les rendez-vous que vous créerez apparaîtront ici avec leur statut de suivi complet.</p>
      </div>
    </div>
  );
}

export default Tracking;


